import {
  ACTIVATE_AGENT_URL,
  ADD_AGENT_URL,
  AGENT_COMMISSION_SUMMARY_URL,
  AGENT_COMMISSIONS_BY_DATE_URL,
  AGENT_COMMISSIONS_URL,
  AGENT_LIST_URL,
  APPROVE_AGENT_URL,
  DEACTIVATE_AGENT_URL,
  EDIT_AGENT_URL,
  GET_AGENT_DETAILS,
  REJECT_AGENT_URL,
  VIEW_AGENT_URL,
} from "../../constant";
import { multipartRequest, resourceRequest } from "../calls";

/* -------- AGENTS ---------- */
export function doFetchAgent(token) {
  const data = {};
  return resourceRequest(token, AGENT_LIST_URL, data);
}

export function doAddAgent(token, data) {
  return multipartRequest(token, ADD_AGENT_URL, data);
}

export function doViewAgent(token, data) {
  return resourceRequest(token, VIEW_AGENT_URL, data);
}

export function doEditAgent(token, data) {
  return multipartRequest(token, EDIT_AGENT_URL, data);
}

export function doActivateAgent(token, data) {
  return resourceRequest(token, ACTIVATE_AGENT_URL, data);
}

export function doDeactivateAgent(token, data) {
  return resourceRequest(token, DEACTIVATE_AGENT_URL, data);
}

export function doApproveAgent(token, data) {
  return resourceRequest(token, APPROVE_AGENT_URL, data);
}

export function doRejectAgent(token, data) {
  return resourceRequest(token, REJECT_AGENT_URL, data);
}

export function doGetAgentDetails(token, data) {
  return resourceRequest(token, GET_AGENT_DETAILS, data);
}

export function doGetAgentCommissionSummary(token, data) {
  return resourceRequest(token, AGENT_COMMISSION_SUMMARY_URL, data);
}

export function doGetAgentCommissions(token, data) {
  return resourceRequest(token, AGENT_COMMISSIONS_URL, data);
}

export function doGetAgentCommissionsByDate(token, data) {
  return resourceRequest(token, AGENT_COMMISSIONS_BY_DATE_URL, data);
}
